import { z } from 'zod';
import { pin } from '../schema-methods';

export const disableTwoFaSchema = (t: { required: string; incorrectPin: string }) =>
  z.object({
    pin: pin(t),
  });

export type DisableTwoFaSchema = z.infer<ReturnType<typeof disableTwoFaSchema>>;
